import { render, staticRenderFns } from "./Creator.vue?vue&type=template&id=b6bea040&scoped=true"
import script from "./Creator.vue?vue&type=script&lang=js"
export * from "./Creator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bea040",
  null
  
)

export default component.exports